/*
 * drawer-swipe.js — Swipe-to-close « suivre le doigt » pour les drawers latéraux.
 *
 * Geste tactile mobile : le panneau suit le doigt en temps réel, ferme si le
 * glissement dépasse un seuil de distance/vélocité dans le sens de fermeture,
 * sinon revient élastiquement en place. Réutilisable pour tout panneau latéral.
 *
 * Usage :
 *   window.enableSwipeToClose(panel, {
 *     side: 'right' | 'left',   // côté d'où sort le panneau (panier=right, menu=left)
 *     onClose: function () {},  // fermeture native du drawer
 *     isOpen: function () {}    // (optionnel) renvoie true si le drawer est ouvert
 *   });
 *
 * Garde-fous : verrouillage d'axe (ne casse pas le scroll vertical), respecte
 * prefers-reduced-motion, nettoie le style inline après chaque geste pour rendre
 * la main à l'animation CSS native, anti double-binding via data-swipe-bound.
 */
(function () {
  var DISTANCE_RATIO = 0.35; // part de la largeur du panneau à dépasser pour fermer
  var VELOCITY_MIN = 0.5; // px/ms dans le sens de fermeture pour fermer au flick
  var AXIS_LOCK_PX = 8; // mouvement minimal avant de décider horizontal vs vertical
  var ANIM_MS = 200; // durée de l'animation de commit / retour élastique

  function enableSwipeToClose(panel, options) {
    if (!panel || panel.dataset.swipeBound === 'true') return;
    panel.dataset.swipeBound = 'true';

    options = options || {};
    var closeSign = options.side === 'left' ? -1 : 1; // sens de fermeture sur l'axe X
    var onClose = typeof options.onClose === 'function' ? options.onClose : function () {};
    var isOpen = typeof options.isOpen === 'function' ? options.isOpen : function () { return true; };
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    var startX = 0;
    var startY = 0;
    var dx = 0;
    var startTime = 0;
    var width = 1;
    var dragging = false;
    var axisLocked = false;
    var horizontal = false;

    function onTouchStart(e) {
      if (e.touches.length !== 1 || !isOpen()) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dx = 0;
      startTime = Date.now();
      width = panel.offsetWidth || 1;
      dragging = true;
      axisLocked = false;
      horizontal = false;
    }

    function onTouchMove(e) {
      if (!dragging) return;
      dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;

      if (!axisLocked) {
        if (Math.abs(dx) < AXIS_LOCK_PX && Math.abs(dy) < AXIS_LOCK_PX) return;
        axisLocked = true;
        horizontal = Math.abs(dx) > Math.abs(dy);
        if (horizontal) panel.style.transition = 'none'; // suivi 1:1 sans lissage
      }

      if (!horizontal) return; // mouvement vertical : on laisse scroller la liste

      // Seul le sens de fermeture déplace le panneau ; l'autre sens reste à 0.
      var translate = closeSign === 1 ? Math.max(0, dx) : Math.min(0, dx);
      e.preventDefault(); // bloque le scroll/overscroll pendant le drag horizontal
      panel.style.transform = 'translateX(' + translate + 'px)';
    }

    function onTouchEnd() {
      if (!dragging) return;
      dragging = false;
      if (!horizontal) { clearInline(); return; }

      var distance = closeSign * dx; // positif = déplacé vers la fermeture
      var velocity = distance / (Date.now() - startTime || 1);
      var shouldClose = distance > width * DISTANCE_RATIO || velocity > VELOCITY_MIN;

      if (shouldClose) {
        commitClose();
      } else {
        animateTo(0, clearInline);
      }
    }

    function commitClose() {
      animateTo(closeSign * width, function () {
        // Fermeture native d'abord (retire .active / .menu-opening), puis on
        // nettoie le style inline : la position CSS « fermé » prend le relais
        // sans repasser une frame par la position ouverte (pas de saut).
        onClose();
        clearInline();
      });
    }

    // Anime la translation inline jusqu'à `targetPx` puis exécute `done`.
    function animateTo(targetPx, done) {
      if (reduceMotion.matches) { done(); return; }
      var finished = false;
      var finish = function () {
        if (finished) return;
        finished = true;
        panel.removeEventListener('transitionend', finish);
        done();
      };
      panel.style.transition = 'transform ' + ANIM_MS + 'ms ease';
      // force reflow pour que la transition parte de la position courante
      void panel.offsetWidth;
      panel.style.transform = 'translateX(' + targetPx + 'px)';
      panel.addEventListener('transitionend', finish);
      setTimeout(finish, ANIM_MS + 80); // filet de sécurité si transitionend manque
    }

    function clearInline() {
      panel.style.transition = '';
      panel.style.transform = '';
    }

    panel.addEventListener('touchstart', onTouchStart, { passive: true });
    panel.addEventListener('touchmove', onTouchMove, { passive: false });
    panel.addEventListener('touchend', onTouchEnd, { passive: true });
    panel.addEventListener('touchcancel', onTouchEnd, { passive: true });
  }

  window.enableSwipeToClose = enableSwipeToClose;
})();
